import { render, staticRenderFns } from "./Journal.vue?vue&type=template&id=f37f2c80&scoped=true"
import script from "./Journal.vue?vue&type=script&lang=js"
export * from "./Journal.vue?vue&type=script&lang=js"
import style0 from "./Journal.vue?vue&type=style&index=0&id=f37f2c80&prod&lang=scss&scoped=true"
import style1 from "./Journal.vue?vue&type=style&index=1&id=f37f2c80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f37f2c80",
  null
  
)

export default component.exports